export default {"src":"/_next/static/media/envirocropsColoured.e69bd767.svg","height":34,"width":208,"blurWidth":0,"blurHeight":0};